import { Component, Input, OnInit } from "@angular/core";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { TranslateService } from "@ngx-translate/core";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Tool } from "src/app/models/Tool";

import { NotifierService } from "../../services/notifier.service";
import { ToolService } from "../../services/tool.service";
import { AuthService } from "./../../services/auth.service";
import { PoBasketService } from "./../../services/po-basket.service";

@Component({
  selector: "purchase-order-button",
  templateUrl: "./purchase-order-button.component.html",
  styleUrls: ["./purchase-order-button.component.scss"],
  standalone: false,
})
export class PurchaseOrderButtonComponent implements OnInit {
  faShoppingCart = faShoppingCart;
  @Input() tool: Tool;

  constructor(
    private basket: PoBasketService,
    public toolService: ToolService,
    public authService: AuthService,
    private notifierService: NotifierService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.tool.addedToPO = this.basket.isToolAlreadyInBasket(this.tool);
  }

  async updateItemAsync() {
    if (!this.tool.addedToPO) {
      this.basket.add(this.tool);

      const translation = await this.translateService
        .get(LocalizationConstants.BASKET_ITEM_PURCHASE_ORDER_ADDED_MESSAGE)
        .toPromise();

      this.notifierService.showNotification(
        this.tool.serialNumber,
        translation,
        "",
        RouteNameConstants.PURCHASE_ORDER,
      );
    } else {
      this.basket.remove(this.tool);

      const translation = await this.translateService
        .get(LocalizationConstants.BASKET_ITEM_PURCHASE_ORDER_REMOVED_MESSAGE)
        .toPromise();

      this.notifierService.showNotification(
        this.tool.serialNumber,
        translation,
        "",
        RouteNameConstants.PURCHASE_ORDER,
      );
    }

    this.tool.addedToPO = !this.tool.addedToPO;
  }
}
